/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { absDependencies } from './dependenciesAbs.generated';
import { addScalarDependencies } from './dependenciesAddScalar.generated';
import { detDependencies } from './dependenciesDet.generated';
import { divideScalarDependencies } from './dependenciesDivideScalar.generated';
import { identityDependencies } from './dependenciesIdentity.generated';
import { matrixDependencies } from './dependenciesMatrix.generated';
import { multiplyDependencies } from './dependenciesMultiply.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { unaryMinusDependencies } from './dependenciesUnaryMinus.generated';
import { createInv } from '../../factoriesAny.js';
export var invDependencies = {
  absDependencies: absDependencies,
  addScalarDependencies: addScalarDependencies,
  detDependencies: detDependencies,
  divideScalarDependencies: divideScalarDependencies,
  identityDependencies: identityDependencies,
  matrixDependencies: matrixDependencies,
  multiplyDependencies: multiplyDependencies,
  typedDependencies: typedDependencies,
  unaryMinusDependencies: unaryMinusDependencies,
  createInv: createInv
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesInv.generated.js
// module id = 166
// module chunks = 0